import React, { createContext } from 'react';
import { withTheme } from 'emotion-theming';
// Default to 'sm' breakpoint.
// detect-mobile will replace this value during server render
const BreakpointContext = createContext('sm');
export const BreakpointConsumer = withTheme(({ children, theme: { labels } }) => (React.createElement(BreakpointContext.Consumer, null, breakpoint => children({
    breakpointIndex: labels.indexOf(breakpoint),
    breakpointLabel: breakpoint
}))));
export const BreakpointProvider = BreakpointContext.Provider;
//# sourceMappingURL=BreakpointProvider.js.map